import { Injectable } from '@angular/core';
import { defaultLanguage, genericLanguageMap, supportedLanguages, translations } from './translation.config';
import { I18nService } from '@livemaps/i18n';

@Injectable()
export class TranslationService {
  constructor(public i18nService: I18nService) {}

  getTranslation() {
    return translations[
      this.i18nService.getLanguageInUse(supportedLanguages, defaultLanguage, genericLanguageMap, true)
    ];
  }
}
